



















import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Facet } from '@/models/dynamiclist';

@Component({})
export default class SelectedFacetsComponent extends Vue {

    @Getter('selectedFacets')
    public selectedFacets!: { [filterId: string]: Facet[] };

    @Action('toggleFacet')
    private toggleFacet!: (cmd: { filterId: string, facetId: string}) => void;

    @Action('fetchResultsDebounced')
    private fetchResultsDebounced!: () => void;

    @Action('clearFacets')
    private clearFacets!: () => void;

    public hasFacets(): boolean {
        let facetCount = 0;

        for (const filterId of Object.keys(this.selectedFacets)) {
            const facets = this.selectedFacets[filterId];
            facetCount += facets.length;
        }

        return facetCount > 0;
    }

    public toggle(facetId: string, filterId: string): void {
        this.toggleFacet({ facetId, filterId });
        this.fetchResultsDebounced();
    }

    public clear(): void {
        this.clearFacets();
        this.fetchResultsDebounced();
    }
}
